module.exports = __webpack_public_path__ + "img/hometitle.cf8d22e0.png";